import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "TimeOff",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getTimeOff, getTimeOffError, getTimeOffSuccess } = slice.actions;

reducerRegistry.register("timeOff", reducer);
